import { Suspense, type ReactElement, type ReactNode } from "react";
import { CmtsRouteErrorBoundary } from "../errors/RouteErrorBoundary.js";
import { CmtsRouteLoadingFallback } from "./CmtsRouteLoadingFallback.js";

export function CmtsLazyRouteBoundary(props: { readonly children: ReactNode; readonly label?: string | undefined; readonly routePath?: string | undefined }): ReactElement {
  return (
    <CmtsRouteErrorBoundary routePath={props.routePath}>
      <Suspense fallback={<CmtsRouteLoadingFallback label={props.label ?? "Loading CMTS page"} />}>
        {props.children}
      </Suspense>
    </CmtsRouteErrorBoundary>
  );
}
